import Stats from './stats';
import DocumentsToProcess from './documentsToProcess';

const DepositorSectionView = () => (
  <>
    <Stats/>

    <DocumentsToProcess/>
  </>
);

export default DepositorSectionView;
